const Associations = () => {
    return (
        <div>
            <h1>Mon Associations</h1>
        </div>
    );
};

export default Associations;
